import { CommonModule as NgCommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatLegacyTabsModule as MatTabsModule } from "@angular/material/legacy-tabs";
import { TranslateModule } from "@ngx-translate/core";
import { ExpandableTextModule } from "@obg/mat.ui.common/expandable-text";
import { OverlaySpinnerModule } from "@obg/mat.ui.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { RouterModule } from "@obg/ngx.router";
import { ObgMatTabsScrollModule, SmTermsAndConditionsAccordionModule } from "@obg/ngx.ui.common";
import { ComponentFactoryService } from "@obg/ngx.ui.core";
import { GlobalUiModule } from "@obg/ngx.ui.global";
import { GlobalUiLazyImageModule } from "@obg/ngx.ui.global.lazy-image";

import { OmsLocalizeTimeModule } from "../oms-localize-time/oms-localize-time.module";

import { SmOmsTabsContainer } from "./sm-oms-tabs/sm-oms-tabs.container";
import { SmOmsContainer } from "./sm-oms.container";

const OMS_DIRECTIVES = [SmOmsContainer, SmOmsTabsContainer];

const MAT_MODULES: any[] = [MatButtonModule, MatCardModule, MatTabsModule];

@NgModule({
	imports: [
		NgCommonModule,
		...MAT_MODULES,
		GlobalUiModule,
		GlobalUiLazyImageModule,
		RouterModule,
		CoreContentModule,
		SmTermsAndConditionsAccordionModule,
		TranslateModule,
		ExpandableTextModule,
		ObgMatTabsScrollModule,
		OmsLocalizeTimeModule,
		OverlaySpinnerModule,
	],
	declarations: OMS_DIRECTIVES,
	exports: OMS_DIRECTIVES,
})
export class SmOmsUiModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, SmOmsTabsContainer);
	}
}
